var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerLeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.939,9.439l-20.5,20.5c-0.586,0.586-0.586,1.535,0,2.121l6.5,6.5c0.586,0.586,1.535,0.586,2.121,0L24,25.621 l12.939,12.939C37.232,38.854,37.616,39,38,39s0.768-0.146,1.061-0.439l6.5-6.5c0.586-0.586,0.586-1.535,0-2.121l-20.5-20.5 C24.475,8.854,23.525,8.854,22.939,9.439z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLeading);
export default __webpack_public_path__ + "static/media/banner-leading.b0bc31d0fa98fd069af003fa0dfdb270.svg";
export { ForwardRef as ReactComponent };